import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  theme: process.env.VUE_APP_THEME=='dark' ? {
    primary: '#505050',
    accent: '#606060',
    secondary: '#404040',
    success: '#4CAF50',
    info: '#2196F3',
    warning: '#FB8C00',
    error: '#FF5252'
  } : {
    primary: '#0066CC',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  options: {
    customProperties: true
  },
  iconfont: 'fa',
})
